module.exports = __webpack_public_path__ + "img/tedx.7360a8aa.png";